import { render, staticRenderFns } from "./ResearchInstructorSave.vue?vue&type=template&id=886729e0&"
import script from "./ResearchInstructorSave.vue?vue&type=script&lang=js&"
export * from "./ResearchInstructorSave.vue?vue&type=script&lang=js&"
import style0 from "./ResearchInstructorSave.vue?vue&type=style&index=0&id=886729e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports